var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgProductShortLine = function SvgProductShortLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 101,
    height: 105,
    fill: "none",
    preserveAspectRatio: "none",
    viewBox: "0 0 101 105"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#paint0_linear_129_15347)",
    strokeDasharray: "3 3",
    d: "M1 104.364V66.979c0-9.06 6.141-16.452 17.25-16.852.314-.011 60.472-.017 60.795-.017 11.71 0 21.204-7.553 21.204-16.87V0"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_129_15347",
    x1: -110.25,
    x2: -110.25,
    y1: 29.5,
    y2: 103.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7F7678"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEE"
  })))));
};
export { SvgProductShortLine as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAxIiBoZWlnaHQ9IjEwNSIgdmlld0JveD0iMCAwIDEwMSAxMDUiIGZpbGw9Im5vbmUiIHByZXNlcnZlQXNwZWN0UmF0aW89Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0xIDEwNC4zNjRMMSA2Ni45Nzg5QzEgNTcuOTE4OSA3LjE0MTA3IDUwLjUyNzEgMTguMjQ5NSA1MC4xMjdDMTguNTYzOSA1MC4xMTU3IDc4LjcyMjQgNTAuMTA5OSA3OS4wNDQ4IDUwLjEwOTlDOTAuNzU1OCA1MC4xMDk5IDEwMC4yNDkgNDIuNTU3NCAxMDAuMjQ5IDMzLjI0MDlMMTAwLjI0OSA5LjU4OTExZS0wNSIgc3Ryb2tlPSJ1cmwoI3BhaW50MF9saW5lYXJfMTI5XzE1MzQ3KSIgc3Ryb2tlLWRhc2hhcnJheT0iMyAzIi8+CjxkZWZzPgo8bGluZWFyR3JhZGllbnQgaWQ9InBhaW50MF9saW5lYXJfMTI5XzE1MzQ3IiB4MT0iLTExMC4yNSIgeTE9IjI5LjUiIHgyPSItMTEwLjI1IiB5Mj0iMTAzLjUiIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIj4KPHN0b3Agc3RvcC1jb2xvcj0iIzdGNzY3OCIvPgo8c3RvcCBvZmZzZXQ9IjEiIHN0b3AtY29sb3I9IiNGRkVFRUUiLz4KPC9saW5lYXJHcmFkaWVudD4KPC9kZWZzPgo8L3N2Zz4K";